import { render, staticRenderFns } from "./AllForeignCessationSubmissions.vue?vue&type=template&id=14c47516&scoped=true&"
import script from "./AllForeignCessationSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllForeignCessationSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllForeignCessationSubmissions.vue?vue&type=style&index=0&id=14c47516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c47516",
  null
  
)

export default component.exports